import { render, staticRenderFns } from "./StakeFrame.vue?vue&type=template&id=9137eece&scoped=true&lang=pug"
import script from "./StakeFrame.vue?vue&type=script&lang=js"
export * from "./StakeFrame.vue?vue&type=script&lang=js"
import style0 from "./StakeFrame.vue?vue&type=style&index=0&id=9137eece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9137eece",
  null
  
)

export default component.exports